module.exports =
`
# 業務合作

MUZIK Air 是全球最大古典音樂平台，彈指便可輕鬆享受音樂。透過 MUZIK Air 的悠揚豐富的音樂，您不只能接觸到喜愛古典樂的人 們，更能透過我們的情境分類與社群新聞、富有生活情感的文章，接觸到更多喜歡音樂跟生活結合的客戶。現在就填寫下列表單，我們的業務人員會洽談您的需求。

`
